import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';

@Component({
  selector: 'vit-drawing-history',
  templateUrl: './drawing-history.component.html',
  styleUrls: ['./drawing-history.component.scss']
})
export class DrawingHistoryComponent implements OnInit {

  constructor(public sessionService: SessionService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/menu-bar/drawing-history/drawing-history.component.ts